import React, { useState } from 'react'

import { Button } from 'react-admin'

import { useSelector, useDispatch } from 'react-redux'

import * as actions from 'customReducers/popupReducer/actions'

import { CreateToolbar, AsidePreview, CreateForm } from '../containers'

import { Drawer } from 'components'

import { CreateStylesheetPopup } from 'modules/stylesheet'

interface PopupModuleStateProps {
  popupModule: {
    formData: object
    openStylesheets: boolean
  }
}

interface ResponseItemProps {
  id: number
  slug?: string
  path?: string
  title?: string
  type?: string
  vimeo_id?: string
}

export const CreatePopup = (props: any) => {
  const dispatch = useDispatch()
  const {
    showAside = false,
    shouldRedirect = true,
    closeDrawer = false,
    onSubmitSuccess = () => {},
    onSubmitFailure = () => {},
  } = props

  const popupModuleState = useSelector(
    (state: PopupModuleStateProps) => state.popupModule,
  )

  const [formData, setFormData] = useState([])

  return (
    <>
      <Drawer open={popupModuleState.openStylesheets} anchor="right">
        <CreateStylesheetPopup
          {...props}
          shouldRedirect={false}
          showAside={false}
          onSubmitSuccess={(data: ResponseItemProps) =>
            dispatch(actions.stylesheetsDialog())
          }
          onSubmitFailure={(data: ResponseItemProps) => onSubmitFailure(data)}
          closeDrawer={
            <Button
              label="Cancelar"
              redirect={false}
              submitOnEnter={false}
              variant="text"
              color="primary"
              onClick={() => dispatch(actions.stylesheetsDialog())}
            />
          }
        />
      </Drawer>
      <CreateForm
        {...props}
        setFormData={setFormData}
        toolbar={<CreateToolbar closeDrawer={closeDrawer} />}
        aside={showAside ? <AsidePreview formData={formData} /> : <></>}
        onSubmitSuccess={onSubmitSuccess}
        onSubmitFailure={onSubmitFailure}
        shouldRedirect={shouldRedirect}
        resource="cms/grouper/popup"
      />
    </>
  )
}
